import { createSelector, Selector } from 'reselect';

import { State } from '@/store';
import { HolidayRecord, HolidayStatus, SlackDirectory } from '@/store/reducers/slack';

const selectSlackState = (state: State) => state.slackReducer;

export const selectSlackDirectory: Selector<State, SlackDirectory | null> = createSelector(
  selectSlackState,
  ({ directory }) => directory,
);

export const selectHolidayRecords: Selector<State, HolidayRecord[] | null> = createSelector(
  selectSlackState,
  ({ holidays }) => holidays,
);

export const selectHolidayStatus: Selector<State, HolidayStatus | null> = createSelector(
  selectSlackState,
  ({ holidayStatus }) => holidayStatus,
);
